/// <reference path="../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import {combineClassNames} from "../Utils/ReactUtils";

export interface MessageBoxPanelProps {
    className?: string;
    header?: string;
    message: string;
    hideCancelButton: boolean;
    cancelButtonLabel: string;
    okButtonLabel: string;
    okButtonClass?: string;
}

export interface MessageBoxPanelState {
}

export class MessageBoxPanel extends React.Component<MessageBoxPanelProps, MessageBoxPanelState> {
    private _okBtn: React.ReactInstance;
    private _cancelBtn: React.ReactInstance;
    private _currentFocusedElement: React.ReactInstance;

    constructor(props) {
        super(props);
        this.focusToggle = this.focusToggle.bind(this);
    }

    private focusToggle(): void {

        if(this._currentFocusedElement == null){
            this._currentFocusedElement = this._okBtn;
        }

        if(!this.props.hideCancelButton && this._currentFocusedElement == this._okBtn) {
            this._currentFocusedElement = this._cancelBtn;
        } else {
            this._currentFocusedElement = this._okBtn;
        }

         const _focusElt = ReactDOM.findDOMNode(this._currentFocusedElement) as HTMLElement;
        _focusElt && _focusElt.focus();
    }

    render() {
        var okClass = this.props.okButtonClass || "default-button";
        var cancelButton = this.props.hideCancelButton ?
            null : <button type="button" ref={(btn) => this._cancelBtn = btn} className={combineClassNames("cancel-button", "m-button-secondary-md")}>{this.props.cancelButtonLabel}</button>
        return (
            <div className={"message-box " + (this.props.className || '')}>
                <div
                    className="focus-trap"
                    aria-hidden="true"
                    onFocus={this.focusToggle}
                    tabIndex={0}
                />
                {this.props.header? <h2>{this.props.header}</h2> : null}
                <div className="message-box-message">{this.props.message}</div>
                <div className="button-panel">
                    {cancelButton}
                    <button type="submit" onFocus={() => this._currentFocusedElement = this._okBtn} className={combineClassNames("ok-button", okClass)}  ref={(btn) => this._okBtn = btn}>{this.props.okButtonLabel}</button>
                </div>
                <div
                    className="focus-trap"
                    aria-hidden="true"
                    onFocus={this.focusToggle}
                    tabIndex={0}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/Views/MessageBox.tsx